export const getNickname = (nickame: string) => {
  if (nickame === "HOME" || nickame === "Casa") return "Casa";
  if (nickame === "WORK" || nickame === "Trabajo") return "Trabajo";
  return nickame;
};
